export default __webpack_public_path__ + "static/media/email.9f01d4e2.svg";